import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

@Component({
  selector: 'basin-formly-textbox-with-copy',
  templateUrl: './formly-textbox-with-copy.component.html',
  styleUrls: ['./formly-textbox-with-copy.component.scss'],
})
export class FormlyTextboxWithCopyComponent extends FieldType {
  copyInputMessage(inputElement) {
    const textToCopy = inputElement.value
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy)
    }
  }
}
